// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {HandwritingDataPerPage} from '../search-index/handwriting-data-per-page.js'

export class HandwritingSearchIndex {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): HandwritingSearchIndex {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsHandwritingSearchIndex(
    bb: flatbuffers.ByteBuffer,
    obj?: HandwritingSearchIndex
  ): HandwritingSearchIndex {
    return (obj || new HandwritingSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsHandwritingSearchIndex(
    bb: flatbuffers.ByteBuffer,
    obj?: HandwritingSearchIndex
  ): HandwritingSearchIndex {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new HandwritingSearchIndex()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  pages(index: number, obj?: HandwritingDataPerPage): HandwritingDataPerPage | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new HandwritingDataPerPage()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  pagesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  version(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0
  }

  static startHandwritingSearchIndex(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addPages(builder: flatbuffers.Builder, pagesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, pagesOffset, 0)
  }

  static createPagesVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startPagesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addVersion(builder: flatbuffers.Builder, version: number) {
    builder.addFieldInt32(1, version, 0)
  }

  static endHandwritingSearchIndex(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // pages
    return offset
  }

  static createHandwritingSearchIndex(
    builder: flatbuffers.Builder,
    pagesOffset: flatbuffers.Offset,
    version: number
  ): flatbuffers.Offset {
    HandwritingSearchIndex.startHandwritingSearchIndex(builder)
    HandwritingSearchIndex.addPages(builder, pagesOffset)
    HandwritingSearchIndex.addVersion(builder, version)
    return HandwritingSearchIndex.endHandwritingSearchIndex(builder)
  }
}
